import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ExcelButton from '../excel/ExcelButton';
import PrintButton from './PrintButton';
import styles from './printButton.module.scss';
/**
 * Печать и выгрузка рядом.
 *
 * Отчёт почти всегда идёт дальше: на бумаге — на совещание и в дело, в
 * книге — чтобы дополнить своими колонками. Поэтому обе кнопки стоят
 * вместе и одинаково выглядят на всех экранах: искать их каждый раз
 * заново человек не должен.
 */
const ReportActions = ({ source, printSource, fileName, name, meta, portrait, compact, className }) => (_jsxs("div", Object.assign({ className: `${styles.row} ${className || ''}`, "data-noprint": true }, { children: [_jsx(PrintButton, { source: printSource || source, title: name, meta: meta, portrait: portrait, compact: compact }), _jsx(ExcelButton, { source: source, fileName: fileName, name: name, meta: meta, compact: compact })] })));
export default ReportActions;
